import styled from "@emotion/styled";
import {
  AllCaps,
  Box,
  Container,
  FlexRow,
  H2,
  IconEthereum,
  IconGlobe,
  IconGraduationCap,
  Link,
  Stack,
  Text,
} from "atoms";
import { constants } from "config";

function HomeAboutHUG() {
  return (
    <Wrapper>
      <Container width="lg">
        <Stack gap="lg">
          <Container width="xs" style={{ textAlign: "center" }}>
            <Stack gap="sm">
              <H2 size="h1">
                What&rsquo;s <AllCaps>Hug</AllCaps>?
              </H2>
              <Text>
                <AllCaps>Hug</AllCaps> is a global community dedicated to artist
                discovery in the evolving and growing world of digital art. We
                provide accessible education and one-of-a-kind opportunities to
                help innovative creators grow and build meaningful connections
                with their&nbsp;audience.
              </Text>
            </Stack>
          </Container>
          <FlexRow alignItems="stretch" gap="site">
            <SBox>
              <Stack gap="sm">
                <FlexRow justifyContent="flex-end" style={{ fontSize: 50 }}>
                  <IconGlobe accent="accent1" />
                </FlexRow>
                <H2 as="h3" size="xl">
                  Here for the&nbsp;Art
                </H2>
                <Text size="xs" bold>
                  <AllCaps>Hug</AllCaps> is the most inclusive destination for
                  digital artists and art&nbsp;lovers.
                </Text>
                <Text size="xs">
                  Our mission is to help artists become creative entrepreneurs,
                  while democratizing access to art through technology and
                  education. <AllCaps>Hug</AllCaps> is committed to promoting{" "}
                  <abbr title="Diversity, Equity, and Inclusion">DEI</abbr> in
                  the arts and spotlighting creators from all walks
                  of&nbsp;life.
                </Text>
                <Link to="/about" variant="primary" size="sm" arrow="r">
                  About us
                </Link>
              </Stack>
            </SBox>
            <SBox>
              <Stack gap="sm">
                <FlexRow justifyContent="flex-end" style={{ fontSize: 50 }}>
                  <IconGraduationCap accent="accent3" />
                </FlexRow>
                <H2 as="h3" size="xl">
                  Artist Opportunities
                </H2>
                <Text size="xs" bold>
                  Empowering artists and art lovers with accessible resources on
                  arts and technology.
                </Text>
                <Text size="xs">
                  From downloadable tools and guides to grants and open calls,
                  HUG Studios offers various educational, marketing, and
                  financial resources to elevate your abilities and further your
                  creative practice.
                </Text>
                <Link
                  href={constants.studiosUrl}
                  variant="primary"
                  size="sm"
                  arrow="r"
                >
                  Learn More
                </Link>
              </Stack>
            </SBox>
            <SBox>
              <Stack gap="sm">
                <FlexRow justifyContent="flex-end" style={{ fontSize: 50 }}>
                  <IconEthereum accent="accent4" />
                </FlexRow>
                <H2 as="h3" size="xl">
                  What is an&nbsp;NFT?
                </H2>
                <Text size="xs" bold>
                  We are passionate about NFTs as they help empower the artists
                  we know and love.
                </Text>
                <Text size="xs">
                  A non-fungible token (NFT) is a unique and non-replicable
                  digital asset documented on blockchains like Ethereum. NFTs
                  have been life-changing for artists through proof of ownership
                  and authenticity. Learn more with our community.
                </Text>
                <Link
                  href={constants.discordURL}
                  variant="primary"
                  size="sm"
                  arrow="r"
                  target="_blank"
                >
                  Join our Discord
                </Link>
              </Stack>
            </SBox>
          </FlexRow>
        </Stack>
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.section({
  padding: "2rem 0",
});

const SBox = styled(Box)(({ theme }) => ({
  background: theme.colors.bg,
  "body &": { color: theme.colors.fg },
  flex: "1 1 320px",
  padding: "2rem",
  display: "flex",
  "&>*": {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignContent: "stretch",
  },
  "p+p": {
    flex: 1,
  },
  a: {
    alignSelf: "start",
  },
}));

export { HomeAboutHUG };
